import React from 'react';
import './orders.css';

const Orders = () => {
  return (
    <div className='tableWrapper'>
      <p className='p-pos'>No orders available without inserting API KEY</p>
    </div>
  );
};

export default Orders;
